var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chart"}},[_c('VueApexCharts',{ref:"chart",attrs:{"type":"scatter","width":"100%","height":_vm.smallChart === true ? '200%' : '300%',"options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }